<template>
    <div id="admin-cfdi">
        <div>
            <v-breadcrumbs :items="breadcrumbs">
                <v-icon slot="divider">forward</v-icon>
            </v-breadcrumbs>
        </div>
        <v-container fluid fill-height>
            <v-row>
                <v-col xs="12">
                    <base-material-card color="primary" icon="library_books" title="Consultas de CFDI" class="elevation-1 px-5 py-3">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn fab dark x-small color="secondary" slot="activator" @click.native="open_model" title="Nueva Solicitud" v-tippy>
                                <v-icon dark>add</v-icon>
                            </v-btn>
                        </v-card-actions>

                        <v-card-text>
                            <div id="datagrid">
                                <v-client-table ref="vuetable" :data="items" :columns="config_table.columns" :options="config_table.options" class="elevation-2 pa-2">
                                    <template slot="noResults">
                                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                    </template>
                                    
                                    <template slot="tipo" slot-scope="props">
                                        {{ props.row.tipo.toUpperCase() }}
                                    </template>

                                    <template slot="fecha_de" slot-scope="props">
                                        {{ props.row.fecha_de.substr(0, 10) }}
                                    </template>

                                    <template slot="fecha_a" slot-scope="props">
                                        {{ props.row.fecha_a.substr(0, 10) }}
                                    </template>

                                    <template slot="total" slot-scope="props">
                                        {{ props.row.paquetes !== null ? props.row.paquetes.length : 0 }}
                                    </template>

                                    <template slot="actions" slot-scope="props">
                                        <v-speed-dial :key="props.row._id" direction="left" open-on-hover style="text-align: center;">
                                            <template v-slot:activator>
                                                <v-btn x-small fab dark color="primary">
                                                    <v-icon v-if="fab">mdi-close</v-icon>
                                                    <v-icon v-else>reorder</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-btn v-if="props.row.estatus == 'Creado'" 
                                                x-small fab dark color="blue" 
                                                @click.native="enviar(props.row._id)" title="Autorizar"
                                                v-tippy>
                                                <v-icon>send</v-icon>
                                            </v-btn>
                                            <v-btn v-if="props.row.estatus == 'Autenticado'"
                                                x-small fab dark color="blue" 
                                                @click.native="solicitar(props.row._id)" title="Solicitar"
                                                v-tippy>
                                                <v-icon>send</v-icon>
                                            </v-btn>
                                            <v-btn v-if="props.row.estatus == 'Solicitud Aceptada'"
                                                x-small fab dark color="blue" 
                                                @click.native="verificar(props.row._id)" title="Verificar"
                                                v-tippy>
                                                <v-icon>send</v-icon>
                                            </v-btn>
                                            <v-btn v-if="props.row.estatus == 'Verificado'" 
                                                x-small fab dark color="blue" 
                                                @click.native="descargar_paquetes(props.row._id)" title="Descargar Pauqetes"
                                                v-tippy>
                                                <v-icon>send</v-icon>
                                            </v-btn>
                                            <v-btn v-if="props.row.estatus == 'Descargado'" 
                                                x-small fab dark color="blue" 
                                                @click.native="copiar_bandeja(props.row._id)" title="Enviar a Bandeja"
                                                v-tippy>
                                                <v-icon>send</v-icon>
                                            </v-btn>

                                            <v-btn x-small fab dark color="pink" 
                                                @click.native="eliminar(props.row._id)" title="Eliminar Solicitud"
                                                v-tippy>
                                                <v-icon>delete</v-icon>
                                            </v-btn>
                                        </v-speed-dial>
                                    </template>
                                </v-client-table>
                            </div>
                        </v-card-text>
                    </base-material-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;">
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal">
                        <v-icon @click.native="modal = false" class="white--text">cancel</v-icon>&nbsp;
                        <span class="subheading">
                            <strong>Nueva Solicitud</strong>
                        </span>
                    </v-card>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md text-xs-center>
                        <v-form ref="form" lazy-validation>
                            <v-card-text>
                                <v-container grid-list-md text-xs-center>
                                    <v-row>
                                        <v-col sm="12" md="6" lg="6">
                                            <v-autocomplete :items="tipo_consulta" v-model="model.tipo" :rules="[rules.required]"
                                                item-text="text" item-value="id" label="Tipo de Consulta"></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="6" lg="6">
                                                <v-autocomplete :items="tipos_comprobante" v-model="model.tipo_comprobante" :rules="[rules.required]" label="Tipo de Comprobante" ></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="12" md="6" lg="6">
                                            <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parse_date(model.fecha_de)" v-mask="'####-##-##'"
                                                :rules="[valida_anio, valida_fecha, rules.required]"></v-text-field>
                                            </template>

                                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu1 = false">
                                                Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="6" lg="6">
                                            <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parse_date(model.fecha_a)" v-mask="'####-##-##'"
                                                :rules="[valida_anio, valida_fecha, rules.required]"></v-text-field>
                                            </template>

                                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu2 = false">
                                                Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col sm="12" v-if="model.tipo == 'emitidos'">
                                            <v-combobox v-model="model.rfcs_consulta" :items="[]" hide-selected hint="Máximo 5 RFCs" label="RFCs Consulta" multiple persistent-hint small-chips @change="to_upper">
                                                <template v-slot:no-data>
                                                    <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                Agrega Nuevos precienando <kbd>enter</kbd>
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-combobox>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modal = false">
                                    <v-icon>cancel</v-icon>Cancelar
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn color="success" @click.native="guardar()">
                                    <v-icon>done</v-icon>Guardar
                                </v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.URL = this.$hostname + "cfdi/"
        // this.URL = "http://localhost:8002/cfdi/"
        this.clean_model()
        this.cargar()
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..")
    },
    watch: {
        "model.rfcs_consulta": function (val) {
            if(val.length > 5){
                this.$swal({
                    type: "warning",
                    title: "Advertencia",
                    text: "Máximo de 5 RFCs permitidos",
                    footer: ""
                });
            }
        }
    },
    data: function () {
        return {
            fab: false,
            menu1: false,
            menu2: false,
            breadcrumbs: [
                {
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "CFDI",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Consulta",
                    disabled: true,
                    to: ""
                }
            ],
            modal: false,
            items: [],
            config_table: {
                columns: [
                    "tipo",
                    "tipo_comprobante",
                    "fecha_de",
                    "fecha_a",
                    "rfcs_consulta",
                    "total",
                    "estatus",
                    "error",
                    "actions"
                ],
                options: {
                    filterable: [
                        "tipo",
                        "tipo_comprobante",
                        "estatus",
                        "error",
                    ],
                    headings: {
                        tipo_comprobante: "Tipo Comprobante",
                        fecha_de: "Fecha De",
                        fecha_a: "Fecha A",
                        rfcs_consulta: "RFCs Consulta",
                        actions: "Acciones"
                    }
                }
            },
            model: {},
            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            tipos_comprobante: ["I", "E", "N", "P"],
            tipo_consulta: [{"id": "recibidos", "text": "Recibidos"}, {"id": "emitidos", "text": "Emitidos"}],
        };
    },
    methods: {
        valida_fecha: function(fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida.";
            else
                return true;
        },
        valida_anio: function() {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
                if (Math.abs(diferencia) > 366)
                    return "Periodo máximo de consulta un año. Favor de verificar."
            }
            return true;
        },
        parse_date(date) {
            if (!date) return null;
                return moment(String(date)).format("YYYY-MM-DD");
        },
        to_upper: function(){
            this.model.rfcs_consulta = this.model.rfcs_consulta.map(function(item){
                return item.toUpperCase();
            });
        },
        cargar: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .post(this.URL + "listar/", {rfc: this.model.rfc})
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.items = res.data;
                        this.items.sort(function (a, b) {
                            return new Date(b.created_at) - new Date(a.created_at);
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        open_model: function () {
            this.modal = true;
            this.clean_model();
        },
        clean_model: function () {
            this.model = {
                "rfc": this.$local_storage.get("rfc"),
                "fecha_de": "",
                "fecha_a": "",
                "rfcs_consulta":[],
                "tipo": "",
                "tipo_comprobante": "",
                "created_by": this.$local_storage.get("email")
            };
        },
        guardar: function () {
            if(!this.$refs.form.validate()){
                return false
            }

            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            
            if(this.model.tipo == 'recibidos'){
                this.model.rfcs_consulta = [this.model.rfc]
            }

            axios.post(this.URL + "crear/", this.model).then(res => {
                this.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "El registro se guardó correctamente",
                    footer: ""
                });
            }).catch(error => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al guardar el registro.",
                    footer: ""
                });
            }).finally(() => {
                this.modal = false;
                this.$root.$dialogLoader.hide()
                this.cargar()
            });
        },
        enviar: function (id) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let datos = {
                _id: id,
            };
            axios.post(this.URL + "autenticar/", datos)
                .then((res) => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El registro se envió correctamente",
                        footer: res.data.mensaje
                    });
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al enviar el registro.",
                        footer: error.response.data.mensaje !== undefined ? error.response.data.mensaje : JSON.stringify(error.response.data)
                    });
                    
                }).finally(() => {
                    this.$root.$dialogLoader.hide()
                    this.cargar()
                });
        },
        solicitar: function (id) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let datos = {
                _id: id,
            };
            axios.post(this.URL + "solicitar/", datos)
                .then((res) => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El registro se envió correctamente",
                        footer: res.data.mensaje
                    });
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al enviar el registro.",
                        footer: error.response.data.mensaje !== undefined ? error.response.data.mensaje : JSON.stringify(error.response.data)
                    });
                    
                }).finally(() => {
                    this.$root.$dialogLoader.hide()
                    this.cargar()
                });
        },
        verificar: function (id) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let datos = {
                _id: id,
            };
            axios.post(this.URL + "verificar/", datos)
                .then((res) => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El registro se envió correctamente",
                        footer: res.data.mensaje
                    });
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al enviar el registro.",
                        footer: error.response.data.mensaje !== undefined ? error.response.data.mensaje : JSON.stringify(error.response.data)
                    });
                    
                }).finally(() => {
                    this.$root.$dialogLoader.hide()
                    this.cargar()
                });
        },
        descargar_paquetes: function (id) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let datos = {
                _id: id,
            };
            axios.post(this.URL + "descargar_paquetes/", datos)
                .then((res) => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El registro se envió correctamente",
                        footer: res.data.mensaje
                    });
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al enviar el registro.",
                        footer: error.response.data.mensaje !== undefined ? error.response.data.mensaje : JSON.stringify(error.response.data)
                    });
                    
                }).finally(() => {
                    this.$root.$dialogLoader.hide()
                    this.cargar()
                });
        },
        copiar_bandeja: function (id) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let datos = {
                _id: id,
            };
            axios.post(this.URL + "copiar_bandeja/", datos)
                .then((res) => {
                    this.$swal({
                        type: "success",
                        title: "¡Operación Exitosa!",
                        text: "El registro se envió correctamente",
                        footer: res.data.mensaje
                    });
                })
                .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al enviar el registro.",
                        footer: error.response.data.mensaje !== undefined ? error.response.data.mensaje : JSON.stringify(error.response.data)
                    });
                    
                }).finally(() => {
                    this.$root.$dialogLoader.hide()
                    this.cargar()
                });
        },
        eliminar: function (id) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar la solicitud?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    let datos = {
                        _id: id
                    }
                    axios.post(this.URL + "eliminar/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El registro se eliminó correctamente",
                                footer: ""
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                                footer: ""
                            });
                            console.log(error);
                        }).finally(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargar();
                        });
                }
            });
        },
    },
};
</script>